/* eslint-disable import/prefer-default-export */
import { takeLatest, put, call, all } from 'redux-saga/effects' // eslint-disable-line
import getAllCentersActions, {
    getAllCentersTypes,
} from '../../../redux/centreFormation/getAllCenters'
import getDisabledCentersActions, {
    getDisabledCentersTypes,
} from '../../../redux/centreFormation/getDisabledCenters'
import { Get } from '../../../serveur/axios'

function* getAllCentersSagas({ response: res }) {
    try {
        const response = yield Get(`centreFormation/${res || ''}`)
        if (response.status === 200) {
            if (res)
                yield put(
                    getDisabledCentersActions.getDisabledCentersSuccess(
                        response.data.data
                    )
                )
            else
                yield put(
                    getAllCentersActions.getAllCentersSuccess(
                        response.data.data
                    )
                )
        } else if (res)
            yield put(
                getDisabledCentersActions.getDisabledCentersFailure(
                    response.data.data
                )
            )
        else
            yield put(
                getAllCentersActions.getAllCentersFailure(response.data.data)
            )
    } catch (error) {
        if (res)
            yield put(
                getDisabledCentersActions.getDisabledCentersFailure(error)
            )
        else yield put(getAllCentersActions.getAllCentersFailure(error))
    }
}
export function* getAllCentersSaga() {
    yield takeLatest(
        getAllCentersTypes.GET_ALL_CENTERS_REQUEST,
        getAllCentersSagas
    )
    yield takeLatest(
        getDisabledCentersTypes.GET_DISABLED_CENTERS_REQUEST,
        getAllCentersSagas
    )
}
